const DTI_CALC = "dti_calc";
const TOOLTIP = "tooltip";
const MODAL_DIALOG = "modal_dialog";
export {
  DTI_CALC,
  MODAL_DIALOG,
  TOOLTIP
};
